import {useGrpcRequest} from '@aboutyou/data-fetcher';
// eslint-disable-next-line monorepo/no-internal-import
import {GetWishlistStateResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/service.types';
import {createDataStore} from '../createDataStore';
import {useFullSession} from '../userStore/useSession';
// eslint-disable-next-line monorepo/no-internal-import
import {ReductionsState} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/reductions_state.types';
// eslint-disable-next-line monorepo/no-internal-import
import {useReductionsStateRequestParameter} from '@aboutyou/logic-components/src/features/ReductionsState/useReductionsStateRequestParameter';
// eslint-disable-next-line monorepo/no-internal-import
import {useTargetGroupIdentifier} from '@aboutyou/logic-components/src/shared-deprecated/useTargetGroupIdentifier';
import {useEffect, useRef} from 'react';
import {usePersistSessionStateCallback} from '../sessionStore/session.hooks';
// eslint-disable-next-line monorepo/no-internal-import
import {WishlistService_GetWishlistStateLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/service.grpc.lazy';
// eslint-disable-next-line monorepo/no-internal-import
import {useIsAuthenticated} from '@aboutyou/logic-components/src/features/Authentication/hooks/useIsAuthenticated';

const useExpensiveWishlist = () => {
  const session = useFullSession();
  const reductionsState = useReductionsStateRequestParameter();
  const targetGroup = useTargetGroupIdentifier();
  const persistSessionState = usePersistSessionStateCallback();
  const usedDiscount = useRef<ReductionsState>(reductionsState);
  const previousAuthentication = useRef<boolean>(false);
  const {isAuthenticated} = useIsAuthenticated();

  const response = useGrpcRequest(
    WishlistService_GetWishlistStateLazy,
    {reductionsState, session: session!, targetGroup},
    {
      disabled: !session,
      onSuccess: (wishlistState?: GetWishlistStateResponse) => {
        const hasItemsInWishlist = Boolean(
          wishlistState?.wishlistState.items?.length,
        );
        // we want to delay persisting of the session state as much as possible for legal reasons
        // if an anonymous user doesn't have anything in the basket/basket/or is loggedIn, we don't need to persist the session-id
        if (hasItemsInWishlist) {
          persistSessionState();
        }
      },
    },
  );

  useEffect(() => {
    // only on login, on logout we dont need to do it as we will redirect to home
    // tried using session id as refetchToken but that didn't do anything
    // I would also assume that fetch would be triggered again because of session being part of request properties but it does nothing
    if (
      isAuthenticated !== previousAuthentication.current &&
      !previousAuthentication.current
    ) {
      previousAuthentication.current = isAuthenticated;
      response.refetch();
    }

    // on discount change we want to make sure right product count is shown
    // we are caching everything when product is added but that will only update it for current discount
    // this way we are ensuring that always latest informations are shown
    if (usedDiscount.current !== reductionsState) {
      usedDiscount.current = reductionsState;
      response.refetch();
    }
  }, [response, reductionsState, isAuthenticated]);

  return response;
};

const {Provider, useData: useWishlistMinimalState} =
  createDataStore<GetWishlistStateResponse>({
    defaultValue: undefined,
    useQueryHook: useExpensiveWishlist,
  });

export {Provider as WishlistStateProvider, useWishlistMinimalState};
